import BasePreview from "@/components/builder/blocks/base"
import { define, prop } from "@/components/builder/utils"

function FormCol({ children, col, ...props }) {
  return <BasePreview {...props}>
    <div className={col ? `basis-${col}/12` : 'flex-1'}>
      {children}
    </div>
  </BasePreview>
}

export default define('form-col', FormCol)
  .shared(prop.share('FormCol', 'form-col'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.gridItem())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.layout())
  .build()
